/* Calculadora de gravidez Gotu, v3 (25/09/2026). Tudo dentro de [data-gg]. */
(function () {
  'use strict';
  var raiz = document.querySelector('[data-gg]');
  if (!raiz) return;

  var DIA = 86400000;
  var C = 2 * Math.PI * 96; // perimetro do anel (r = 96)
  var DRIP = raiz.getAttribute('data-drip') || '';
  var CONTACTO_URL = raiz.getAttribute('data-contacto') || '';
  var CAPTURA = raiz.getAttribute('data-captura') === 'depois' ? 'depois' : 'antes';
  var LS = 'gotu-gravidez-v3', LS_SUB = 'gotu-gravidez-sub';
  var MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
  var MES_C = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
  var DSEM = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];
  var TAB_MESES = [[1, 1, 4], [2, 5, 8], [3, 9, 13], [4, 14, 17], [5, 18, 22], [6, 23, 27], [7, 28, 31], [8, 32, 35], [9, 36, 42]];

  function $(n) { return raiz.querySelector('[data-el="' + n + '"]'); }
  function inp(n) { return raiz.querySelector('[data-in="' + n + '"]'); }
  function act(n) { return raiz.querySelector('[data-act="' + n + '"]'); }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { window.localStorage.removeItem(k); } catch (e) {} }

  // ------------------------------------------------------------ datas
  function hoje() { var d = new Date(); return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
  // Dias inteiros por UTC: em hora local, um intervalo que atravesse a
  // mudanca da hora da 89,96 dias e o arredondamento tira um dia.
  function diasEntre(a, b) { return Math.round((Date.UTC(b.getFullYear(), b.getMonth(), b.getDate()) - Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())) / DIA); }
  function mais(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
  function ler(v) { if (!v) return null; var p = String(v).split('-'); if (p.length !== 3) return null; var d = new Date(+p[0], +p[1] - 1, +p[2]); return isNaN(d.getTime()) || d.getFullYear() < 1900 ? null : d; }
  function iso(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function curta(d) { return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear(); }
  function extenso(d) { return d.getDate() + ' de ' + MESES[d.getMonth()] + ' de ' + d.getFullYear(); }
  function comDia(d) { var t = DSEM[d.getDay()] + ', ' + extenso(d); return t.charAt(0).toUpperCase() + t.slice(1); }
  function dm(d) { return d.getDate() + ' ' + MES_C[d.getMonth()]; }
  function intervalo(a, b) {
    if (diasEntre(a, b) === 0) return dm(a) + ' ' + a.getFullYear();
    return dm(a) + (a.getFullYear() !== b.getFullYear() ? ' ' + a.getFullYear() : '') + ' a ' + dm(b) + ' ' + b.getFullYear();
  }
  function semDias(t) { var s = Math.floor(t / 7), d = t % 7; return s + (s === 1 ? ' semana' : ' semanas') + (d ? ' e ' + d + (d === 1 ? ' dia' : ' dias') : ''); }
  function triDe(s) { return s < 14 ? 1 : (s < 28 ? 2 : 3); }
  function mesDe(s) { for (var i = 0; i < TAB_MESES.length; i++) if (s <= TAB_MESES[i][2]) return TAB_MESES[i][0]; return 9; }

  // ------------------------------------------------------------ formulario
  var metodo = 'dum', ciclo = 28;
  var tabs = raiz.querySelectorAll('.gg-tabs [data-metodo]');
  function escolher(m) {
    metodo = m;
    tabs.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-metodo') === m ? 'true' : 'false'); });
    raiz.querySelectorAll('[data-painel]').forEach(function (p) { p.hidden = p.getAttribute('data-painel') !== m; });
    $('erro').hidden = true;
  }
  tabs.forEach(function (b) { b.addEventListener('click', function () { escolher(b.getAttribute('data-metodo')); }); });
  tabs.forEach(function (b, i) {
    b.addEventListener('keydown', function (ev) {
      var n = ev.key === 'ArrowRight' ? 1 : (ev.key === 'ArrowLeft' ? -1 : 0);
      if (!n) return;
      ev.preventDefault();
      var alvo = tabs[(i + n + tabs.length) % tabs.length];
      escolher(alvo.getAttribute('data-metodo')); alvo.focus();
    });
  });

  function mostrarCiclo() { $('cicloTxt').textContent = ciclo + ' dias'; }
  act('ciclo-').addEventListener('click', function () { if (ciclo > 21) { ciclo--; mostrarCiclo(); } });
  act('ciclo+').addEventListener('click', function () { if (ciclo < 40) { ciclo++; mostrarCiclo(); } });

  // O campo de data nativo mostra-se no formato do browser e nao no do site.
  // Escrever a data por extenso tira a duvida entre 02/06 e 06/02.
  ['dum', 'eco', 'dpp', 'con'].forEach(function (k) {
    var c = inp(k), eco = raiz.querySelector('[data-lido="' + k + '"]');
    function mostra() { var d = ler(c.value); eco.textContent = d ? 'Escolheste ' + extenso(d) : ''; }
    c.addEventListener('input', mostra); c.addEventListener('change', mostra);
  });
  (function limites() {
    var h = hoje();
    ['dum', 'eco', 'con'].forEach(function (k) { inp(k).max = iso(h); inp(k).min = iso(mais(h, -320)); });
    inp('dpp').min = iso(mais(h, -21)); inp('dpp').max = iso(mais(h, 300));
  })();

  function tipoCon() { var r = raiz.querySelector('input[name="gg-tipo"]:checked'); return r ? r.value : 'natural'; }
  raiz.querySelectorAll('input[name="gg-tipo"]').forEach(function (r) {
    r.addEventListener('change', function () { $('conRot').textContent = tipoCon() === 'natural' ? 'Data da conceção' : 'Data da transferência do embrião'; });
  });

  function falhar(msg) { var e = $('erro'); e.textContent = msg; e.hidden = false; }

  /** Le o formulario e devolve {dum, metodo, ref} ou lanca a mensagem de erro. */
  function lerFormulario() {
    var h = hoje(), d;
    if (metodo === 'dum') {
      d = ler(inp('dum').value);
      if (!d) throw 'Escolhe o primeiro dia da tua última menstruação.';
      if (d > h) throw 'Essa data está no futuro. Confirma o dia e o ano.';
      // Ciclo diferente de 28 dias: a ovulacao desloca-se e a DUM corrigida
      // tambem. Semanas e DPP saem da mesma data, por isso batem certo.
      return { dum: mais(d, ciclo - 28), metodo: 'dum', ref: d, ciclo: ciclo };
    }
    if (metodo === 'eco') {
      d = ler(inp('eco').value);
      if (!d) throw 'Escolhe o dia em que fizeste a ecografia.';
      if (d > h) throw 'A data da ecografia está no futuro. Confirma o dia e o ano.';
      var t = (+inp('ecoSem').value) * 7 + (+inp('ecoDias').value);
      return { dum: mais(d, -t), metodo: 'eco', ref: d };
    }
    if (metodo === 'dpp') {
      d = ler(inp('dpp').value);
      if (!d) throw 'Escolhe a data prevista do parto que te deram.';
      return { dum: mais(d, -280), metodo: 'dpp', ref: d };
    }
    d = ler(inp('con').value);
    var tipo = tipoCon();
    if (!d) throw tipo === 'natural' ? 'Escolhe a data da conceção.' : 'Escolhe a data da transferência do embrião.';
    if (d > h) throw 'Essa data está no futuro. Confirma o dia e o ano.';
    // FIV: dia 5 = DPP a 261 dias da transferencia; dia 3 = 263 dias.
    var desvio = tipo === 'd5' ? -19 : (tipo === 'd3' ? -17 : -14);
    return { dum: mais(d, desvio), metodo: tipo === 'natural' ? 'con' : 'fiv-' + tipo, ref: d };
  }

  // ------------------------------------------------------------ calculo
  function calcularDe(dum) {
    var h = hoje(), total = diasEntre(dum, h);
    var s = Math.floor(total / 7);
    return {
      dum: dum, total: total, s: s, d: total % 7,
      tri: triDe(s), mes: mesDe(Math.max(s, 1)),
      dpp: mais(dum, 280), faltam: diasEntre(h, mais(dum, 280)),
      conc: mais(dum, 14), termoIni: mais(dum, 259), termoFim: mais(dum, 294),
      pc: Math.max(0, Math.min(1, total / 280))
    };
  }
  function validar(r) {
    if (r.total < 0) throw 'Essa data dá uma gravidez que começa no futuro. Confirma a data.';
    if (r.total > 300) throw 'Essa data dá mais de 42 semanas de gravidez. Confirma o dia e o ano.';
  }

  // ------------------------------------------------------------ marcos
  // Marcos do calendario: vem do dados.py, em JSON na propria pagina.
  var MARCOS = [];
  try { MARCOS = JSON.parse($('marcos').textContent || '[]'); } catch (e) {}
  MARCOS = MARCOS.map(function (m, i) { m._i = i; return m; }).sort(function (a, b) { return a.ini - b.ini || a._i - b._i; });

  var filtro = 'tudo', verPassado = false, atual = null;

  function desenharLinha() {
    var r = atual; if (!r) return;
    var ol = $('linha'); ol.innerHTML = '';
    var passados = 0;
    MARCOS.forEach(function (m) {
      if (filtro !== 'tudo' && m.t !== filtro) return;
      var a = mais(r.dum, m.ini), b = mais(r.dum, m.fim);
      var estado = r.total > m.fim ? 'feito' : (r.total >= m.ini ? 'agora' : 'depois');
      if (estado === 'feito') { passados++; if (!verPassado) return; }
      var li = document.createElement('li');
      li.className = 'gg-marco';
      li.setAttribute('data-estado', estado);
      li.setAttribute('data-tri', triDe(Math.floor(m.ini / 7)));
      if (m.ini === 280) li.setAttribute('data-dpp', '');
      var links = (m.l || []).map(function (x) { return '<a href="' + x[0] + '">' + x[1] + '</a>'; }).join('');
      li.innerHTML = '<div class="gg-marco__c"><div class="gg-marco__top"><span class="gg-marco__data"></span>' +
        (estado === 'agora' ? '<span class="gg-agora-tag">Agora</span>' : '') +
        '<span class="gg-marco__tipo" data-t="' + m.t + '">' + (m.t === 'saude' ? 'Consulta e exame' : 'Preparar') + '</span></div>' +
        '<h3></h3><p></p>' + (links ? '<div class="gg-marco__links">' + links + '</div>' : '') + '</div>';
      li.querySelector('.gg-marco__data').textContent = intervalo(a, b) + (m.ini === m.fim ? '' : ' · ' + Math.floor(m.ini / 7) + ' a ' + Math.floor(m.fim / 7) + ' semanas');
      li.querySelector('h3').textContent = m.h;
      li.querySelector('p').textContent = m.p;
      ol.appendChild(li);
    });
    var bp = act('passado');
    bp.hidden = passados === 0;
    bp.textContent = verPassado ? 'Esconder o que já passou' : 'Mostrar o que já passou (' + passados + ')';
  }
  act('passado').addEventListener('click', function () { verPassado = !verPassado; desenharLinha(); });
  raiz.querySelectorAll('[data-filtro]').forEach(function (b) {
    b.addEventListener('click', function () {
      filtro = b.getAttribute('data-filtro');
      raiz.querySelectorAll('[data-filtro]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      desenharLinha();
    });
  });

  // ------------------------------------------------------------ anel
  (function anelBase() {
    var f = [98 / 280, 98 / 280, 84 / 280], acc = 0, gap = 5;
    ['1', '2', '3'].forEach(function (k, i) {
      var c = raiz.querySelector('.gg-anel__t' + k), L = C * f[i];
      c.style.strokeDasharray = (L - gap) + ' ' + (C - L + gap);
      c.style.strokeDashoffset = String(-acc);
      acc += L;
    });
  })();

  function contarAte(el, fim) {
    var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduz || fim <= 0) { el.textContent = fim; return; }
    var ini = null;
    function passo(t) { if (ini === null) ini = t; var p = Math.min(1, (t - ini) / 700); el.textContent = Math.round(fim * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(passo); }
    requestAnimationFrame(passo);
  }

  // ------------------------------------------------------------ semanas
  var sel = $('sel');
  function artigo(n) { return raiz.querySelector('#semana-' + n); }
  function centrar(b, suave) {
    var destino = b.offsetLeft - (sel.clientWidth - b.offsetWidth) / 2;
    destino = Math.max(0, Math.min(destino, sel.scrollWidth - sel.clientWidth));
    if (sel.scrollTo) sel.scrollTo({ left: destino, behavior: suave ? 'smooth' : 'auto' }); else sel.scrollLeft = destino;
  }
  var semVista = 20;
  function mostrarSemana(n, suave) {
    n = Math.max(4, Math.min(42, n));
    var alvo = artigo(n); if (!alvo) return;
    raiz.querySelectorAll('.gg-sems .gg-sem').forEach(function (a) { a.hidden = a !== alvo; });
    alvo.style.animation = 'none'; void alvo.offsetWidth; alvo.style.animation = '';
    raiz.querySelectorAll('.gg-sel__b').forEach(function (b) {
      if (+b.getAttribute('data-sem') === n) { b.setAttribute('aria-current', 'true'); centrar(b, suave); } else b.removeAttribute('aria-current');
    });
    semVista = n;
  }
  raiz.querySelectorAll('.gg-sel__b').forEach(function (b) { b.addEventListener('click', function () { mostrarSemana(+b.getAttribute('data-sem'), true); }); });
  act('semAnt').addEventListener('click', function () { mostrarSemana(semVista - 1, true); });
  act('semSeg').addEventListener('click', function () { mostrarSemana(semVista + 1, true); });
  raiz.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href^="#semana-"]');
    if (!a) return;
    var m = a.getAttribute('href').match(/^#semana-(\d+)$/);
    if (m && artigo(+m[1])) { mostrarSemana(+m[1], true); }
  });

  // ------------------------------------------------------------ resultado
  function mostrarResultado(dados, rolar) {
    var r = calcularDe(dados.dum);
    atual = r; atual.metodo = dados.metodo; atual.ref = dados.ref;
    var res = $('res');
    res.setAttribute('data-tri', r.tri);

    contarAte($('num'), r.s);
    $('dias').textContent = r.d ? 'e ' + r.d + (r.d === 1 ? ' dia' : ' dias') : 'certinhas';
    $('mesTri').textContent = r.mes + '.º mês · ' + r.tri + '.º trimestre';
    $('arco').style.strokeDashoffset = (C * (1 - r.pc)).toFixed(1);
    $('ponto').style.transform = 'rotate(' + (r.pc * 360).toFixed(1) + 'deg)';

    var sa = Math.max(4, Math.min(42, r.s)), art = artigo(sa);
    var emo = art.querySelector('.gg-emo');
    $('emo').innerHTML = emo ? emo.innerHTML : '';
    $('comp').textContent = art.getAttribute('data-comp');
    $('medida').textContent = art.getAttribute('data-medida');
    requestAnimationFrame(function () { $('regua').style.width = Math.min(100, (+art.getAttribute('data-cm')) / 52 * 100).toFixed(1) + '%'; });

    $('dpp').textContent = comDia(r.dpp);
    $('faltam').innerHTML = '';
    if (r.faltam > 0) { $('faltam').textContent = r.faltam + (r.faltam === 1 ? ' dia' : ' dias'); var sm = document.createElement('small'); sm.textContent = semDias(r.faltam); $('faltam').appendChild(sm); }
    else $('faltam').textContent = r.faltam === 0 ? 'É hoje' : 'A DPP foi há ' + (-r.faltam) + (r.faltam === -1 ? ' dia' : ' dias');
    if (/^fiv-/.test(dados.metodo)) { $('concRot').textContent = 'Transferência'; $('conc').textContent = dm(dados.ref) + ' ' + dados.ref.getFullYear(); }
    else if (dados.metodo === 'con') { $('concRot').textContent = 'Conceção'; $('conc').textContent = dm(dados.ref) + ' ' + dados.ref.getFullYear(); }
    else { $('concRot').textContent = 'Conceção provável'; $('conc').textContent = 'por volta de ' + dm(r.conc); }
    $('termo').textContent = intervalo(r.termoIni, r.termoFim);

    // Esta semana: copia do artigo que ja esta no HTML (uma fonte so)
    var cx = $('estaSem'); cx.innerHTML = '';
    var et = document.createElement('p'); et.className = 'gg-etq'; et.textContent = r.s < 4 ? 'O que vem a seguir' : 'Esta semana';
    var copia = art.cloneNode(true); copia.removeAttribute('id'); copia.hidden = false;
    cx.appendChild(et); cx.appendChild(copia);

    // Fase de agora, com os produtos certos
    var fa = $('faseAgora'); fa.innerHTML = '';
    raiz.querySelectorAll('.gg-fases .gg-fase').forEach(function (f) {
      if (sa >= +f.getAttribute('data-ini') && sa <= +f.getAttribute('data-fim')) {
        var cf = f.cloneNode(true); cf.removeAttribute('id'); cf.classList.add('gg-fase--res'); fa.appendChild(cf);
      }
    });

    raiz.querySelectorAll('.gg-sel__b').forEach(function (b) { if (+b.getAttribute('data-sem') === sa) b.setAttribute('data-atual', 'true'); else b.removeAttribute('data-atual'); });
    mostrarSemana(sa, false);

    verPassado = false; desenharLinha();
    // Quem acabou de dispensar o convite antes do resultado não o deve ver outra vez.
    $('mail').hidden = lsGet(LS_SUB) === '1' || (CAPTURA === 'antes' && jaViuCaptura);
    $('captura').hidden = true;
    res.hidden = false;
    lsSet(LS, JSON.stringify({ dum: iso(dados.dum), metodo: dados.metodo, ref: iso(dados.ref), guardado: iso(hoje()) }));
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'calculadora_gravidez', gravidez_semana: r.s, gravidez_metodo: dados.metodo }); } catch (e) {}
    if (rolar) res.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ------------------------------------------------------------ newsletter
  var pendente = null, jaViuCaptura = false;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  // Avisos por email (dias desde a DUM): quando comeca e quando deixa de fazer
  // sentido. Quatro, alem das boas-vindas: no maximo um email a cada 3 a 6 semanas.
  var AVISOS = [
    { campo: 'Cadeira', tag: 'cadeira', ini: 112, fim: 210 },
    { campo: 'Enxoval', tag: 'enxoval', ini: 154, fim: 238 },
    { campo: 'Final', tag: 'final', ini: 231, fim: 266 },
    { campo: 'Parto', tag: 'parto', ini: 280, fim: 281 }
  ];
  function enviarDrip(email, nome) {
    if (!DRIP) return;
    var r = atual || (pendente && calcularDe(pendente.dum));
    var p = {
      email: email,
      tags: ['calculadora-gravidez', 'newsletter'].concat(r ? ['gravidez-trimestre-' + r.tri] : []),
      eu_consent: 'granted',
      eu_consent_message: 'Quero receber a newsletter da Gotu por email.'
    };
    if (nome) p.first_name = nome;
    if (r) {
      p.Gravidez_DPP = iso(r.dpp);
      p.Gravidez_DUM = iso(r.dum);
      p.Gravidez_Semana = String(r.s);
      p.Gravidez_Metodo = (atual && atual.metodo) || (pendente && pendente.metodo) || '';
      p.Gravidez_Data = iso(hoje());
      p.Gravidez_DPP_Texto = extenso(r.dpp);
      p.Gravidez_Link = location.origin + location.pathname + '?dpp=' + iso(r.dpp);
      // Emails por fase: o workflow do Drip espera ate cada data ("Wait until
      // custom field: date"). So leva a etiqueta quem ainda vai a tempo. Se a
      // fase ja comecou, o email segue uma semana depois das boas-vindas, e
      // nunca dois emails com menos de 7 dias entre eles.
      var h = hoje(), livre = mais(h, 7);
      AVISOS.forEach(function (a) {
        var ini = mais(r.dum, a.ini), fim = mais(r.dum, a.fim);
        if (fim <= h) return;
        var quando = ini > livre ? ini : livre;
        if (quando > fim) return;
        p['Gravidez_Data_' + a.campo] = iso(quando);
        p.tags.push('gravidez-aviso-' + a.tag);
        if (diasEntre(livre, quando) < 7) livre = mais(quando, 7);
      });
    }
    try {
      window._dcq = window._dcq || []; window._dcs = window._dcs || {};
      if (!window._dcs.account) {
        window._dcs.account = DRIP;
        var s = document.createElement('script'); s.async = true; s.src = 'https://tag.getdrip.com/' + DRIP + '.js';
        document.head.appendChild(s);
      }
      window._dcq.push(['identify', p]);
      window._dcq.push(['track', 'Calculadora gravidez', { semana: r ? r.s : '' }]);
    } catch (e) {}
  }
  // Cliente Shopify com a newsletter: o formulario nativo de cliente da a tag
  // "newsletter", que a integracao Drip-Shopify sincroniza.
  function inscreverShopify(email, nome) {
    if (!CONTACTO_URL) return;
    try {
      var fd = new FormData();
      fd.append('form_type', 'customer'); fd.append('utf8', '\u2713');
      fd.append('contact[email]', email);
      if (nome) fd.append('contact[first_name]', nome);
      fd.append('contact[tags]', 'newsletter,calculadora-gravidez');
      fetch(CONTACTO_URL, { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
    } catch (e) {}
  }
  function subscrever(prefixo, erroEl) {
    var email = inp(prefixo + 'Email').value.trim(), nome = inp(prefixo + 'Nome').value.trim(), err = $(erroEl);
    if (!EMAIL_RE.test(email)) { err.textContent = 'Escreve o teu email para subscrever.'; err.hidden = false; inp(prefixo + 'Email').focus(); return false; }
    if (!inp(prefixo + 'News').checked) { err.textContent = 'Para subscrever, marca a caixa da newsletter.'; err.hidden = false; return false; }
    err.hidden = true;
    inscreverShopify(email, nome); enviarDrip(email, nome);
    lsSet(LS_SUB, '1');
    return true;
  }
  act('subscrever').addEventListener('click', function () {
    if (subscrever('p', 'pErro') && pendente) { mostrarResultado(pendente, true); pendente = null; }
  });
  act('saltar').addEventListener('click', function () {
    jaViuCaptura = true;
    if (pendente) { mostrarResultado(pendente, true); pendente = null; }
  });
  act('subscrever2').addEventListener('click', function () {
    if (subscrever('g', 'gErro')) { $('gOk').hidden = false; act('subscrever2').disabled = true; }
  });

  // ------------------------------------------------------------ calcular
  $('form').addEventListener('submit', function (ev) {
    ev.preventDefault();
    $('erro').hidden = true;
    var dados;
    try { dados = lerFormulario(); validar(calcularDe(dados.dum)); } catch (msg) { return falhar(String(msg)); }
    $('voltar').hidden = true;
    var subscrito = lsGet(LS_SUB) === '1';
    if (CAPTURA === 'antes' && !subscrito && !jaViuCaptura) {
      pendente = dados;
      $('res').hidden = true;
      var cap = $('captura'); cap.hidden = false;
      cap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    mostrarResultado(dados, true);
  });

  // ------------------------------------------------------------ acoes
  function aviso(txt) { var t = $('toast'); t.textContent = txt; t.hidden = false; clearTimeout(aviso._t); aviso._t = setTimeout(function () { t.hidden = true; }, 5000); }
  function linkPartilha() { return location.origin + location.pathname + '?dpp=' + iso(atual.dpp); }

  act('partilhar').addEventListener('click', function () {
    if (!atual) return;
    var txt = 'Estou com ' + semDias(Math.max(0, atual.total)) + ' de gravidez. Data prevista do parto: ' + curta(atual.dpp) + '.';
    var url = linkPartilha();
    if (navigator.share) { navigator.share({ title: 'A minha gravidez', text: txt, url: url }).catch(function () {}); return; }
    window.open('https://wa.me/?text=' + encodeURIComponent(txt + ' ' + url), '_blank', 'noopener');
  });
  act('imprimir').addEventListener('click', function () { verPassado = true; desenharLinha(); setTimeout(function () { window.print(); }, 60); });

  function icsData(d) { return iso(d).replace(/-/g, ''); }
  function icsTxt(s) { return String(s).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n'); }
  // Linhas de 75 octetos no maximo (RFC 5545), contados em UTF-8.
  function icsDobrar(l) {
    var out = [], cur = '', n = 0;
    Array.from(l).forEach(function (ch) {
      var cp = ch.codePointAt(0), b = cp < 0x80 ? 1 : (cp < 0x800 ? 2 : (cp < 0x10000 ? 3 : 4));
      if (n + b > (out.length ? 74 : 75)) { out.push(cur); cur = ''; n = 0; }
      cur += ch; n += b;
    });
    out.push(cur);
    return out.map(function (x, i) { return (i ? ' ' : '') + x; }).join('\r\n');
  }
  act('ics').addEventListener('click', function () {
    if (!atual) return;
    var r = atual, h = hoje(), agora = new Date();
    var stamp = agora.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
    var L = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Gotu//Calculadora de gravidez//PT', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH', 'X-WR-CALNAME:A minha gravidez'];
    MARCOS.forEach(function (m, i) {
      var a = mais(r.dum, m.ini), b = mais(r.dum, m.fim);
      if (b < h) return;
      var ini = a < h ? h : a;
      var desc = (m.ini === m.fim ? '' : 'Entre ' + curta(a) + ' e ' + curta(b) + '. ') + m.p + (m.l && m.l[0] ? ' https://gotu.pt' + m.l[0][0] : '');
      L.push('BEGIN:VEVENT', 'UID:gotu-gravidez-' + icsData(r.dum) + '-' + i + '@gotu.pt', 'DTSTAMP:' + stamp,
        'DTSTART;VALUE=DATE:' + icsData(ini), 'DTEND;VALUE=DATE:' + icsData(mais(ini, 1)),
        icsDobrar('SUMMARY:' + icsTxt((m.t === 'saude' ? '' : 'Preparar: ') + m.h)),
        icsDobrar('DESCRIPTION:' + icsTxt(desc)), 'TRANSP:TRANSPARENT', 'END:VEVENT');
    });
    L.push('END:VCALENDAR');
    var blob = new Blob([L.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob); a.download = 'gravidez-gotu.ics';
    document.body.appendChild(a); a.click();
    setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1500);
    aviso('Calendário descarregado. Abre o ficheiro para juntar as datas ao teu calendário.');
  });

  // ------------------------------------------------------------ contas uteis
  var TRI_MES = [0, 1, 1, 1, 2, 2, 2, 3, 3, 3];
  function marcarMes(m) {
    raiz.querySelectorAll('#semanas-em-meses [data-mes]').forEach(function (el) {
      var on = +el.getAttribute('data-mes') === m;
      el.classList.toggle('gg-on', on);
      if (el.tagName === 'BUTTON') el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function resConv(titulo, texto) {
    var out = $('cvRes'); out.innerHTML = '';
    var b = document.createElement('b'); b.textContent = titulo; out.appendChild(b);
    if (texto) { out.appendChild(document.createElement('br')); out.appendChild(document.createTextNode(texto)); }
  }
  function modoConv() { var r = raiz.querySelector('input[name="gg-conv"]:checked'); return r ? r.value : 'sem'; }
  function conv() {
    var modo = modoConv();
    raiz.querySelectorAll('[data-conv]').forEach(function (p) { p.hidden = p.getAttribute('data-conv') !== modo; });
    if (modo === 'sem') {
      var s = parseInt(inp('cvSem').value, 10), d = parseInt(inp('cvDias').value, 10) || 0;
      if (isNaN(s) || s < 0 || s > 42 || d < 0 || d > 6) { resConv('Escreve as semanas (0 a 42) e os dias (0 a 6).'); marcarMes(0); return; }
      var m = mesDe(Math.max(s, 1));
      resConv(m + '.º mês de gravidez', semDias(s * 7 + d) + ', ' + triDe(s) + '.º trimestre. ' + (s * 7 + d < 280 ? 'Faltam ' + semDias(280 - s * 7 - d) + ' para as 40.' : 'Chegaste às 40 semanas.'));
      marcarMes(m);
    } else if (modo === 'mes') {
      var mm = +inp('cvMes').value, t = TAB_MESES[mm - 1];
      resConv('O ' + mm + '.º mês vai das ' + t[1] + ' às ' + (mm === 9 ? 40 : t[2]) + ' semanas', TRI_MES[mm] + '.º trimestre.' + (mm === 9 ? ' O bebé é de termo a partir das 37 semanas.' : ''));
      marcarMes(mm);
    } else {
      var tt = parseInt(inp('cvTotal').value, 10);
      if (isNaN(tt) || tt < 0 || tt > 300) { resConv('Escreve um número de dias entre 0 e 300.'); marcarMes(0); return; }
      var m2 = mesDe(Math.max(1, Math.floor(tt / 7)));
      resConv(tt + (tt === 1 ? ' dia é ' : ' dias são ') + semDias(tt), m2 + '.º mês de gravidez, ' + triDe(Math.floor(tt / 7)) + '.º trimestre.');
      marcarMes(m2);
    }
  }
  ['cvSem', 'cvDias', 'cvTotal'].forEach(function (k) { inp(k).addEventListener('input', conv); });
  inp('cvMes').addEventListener('change', conv);
  raiz.querySelectorAll('input[name="gg-conv"]').forEach(function (r) { r.addEventListener('change', conv); });
  raiz.querySelectorAll('.gg-faixa__m').forEach(function (b) {
    b.addEventListener('click', function () {
      var r = raiz.querySelector('input[name="gg-conv"][value="mes"]'); r.checked = true;
      inp('cvMes').value = b.getAttribute('data-mes'); conv();
    });
  });
  conv();

  function beta() {
    var v1 = parseFloat(String(inp('b1').value).replace(',', '.')), v2 = parseFloat(String(inp('b2').value).replace(',', '.')), hh = parseFloat(inp('bh').value);
    var out = $('bRes');
    if (!(v1 > 0) || !(v2 > 0) || !(hh > 0)) { out.textContent = 'Preenche os dois valores para veres o tempo de duplicação.'; return; }
    if (v2 <= v1) { out.textContent = 'O 2.º valor está igual ou abaixo do 1.º. Mostra estes números à tua equipa de saúde, que é quem os interpreta.'; return; }
    var t = hh * Math.LN2 / Math.log(v2 / v1), sub = (v2 / v1 - 1) * 100;
    out.innerHTML = '';
    out.appendChild(document.createTextNode('Tempo de duplicação: '));
    var b = document.createElement('b'); b.textContent = (t < 100 ? Math.round(t) : Math.round(t / 24) * 24) + ' horas';
    out.appendChild(b);
    out.appendChild(document.createElement('br'));
    out.appendChild(document.createTextNode('Subiu ' + Math.round(sub).toLocaleString('pt-PT') + '% em ' + hh + ' horas.'));
  }
  ['b1', 'b2', 'bh'].forEach(function (k) { inp(k).addEventListener('input', beta); });

  // ------------------------------------------------------------ arranque
  var retomado = null;
  try { retomado = JSON.parse(lsGet(LS) || 'null'); } catch (e) {}

  act('retomar').addEventListener('click', function () {
    if (!retomado) return;
    mostrarResultado({ dum: ler(retomado.dum), metodo: retomado.metodo, ref: ler(retomado.ref) || ler(retomado.dum) }, true);
    $('voltar').hidden = true;
  });
  act('esquecer').addEventListener('click', function () { lsDel(LS); retomado = null; $('voltar').hidden = true; inp('dum').focus(); });

  mostrarSemana(20, false);
  var usouLink = false;
  try {
    var q = new URLSearchParams(location.search);
    var qd = ler(q.get('dpp')), qm = ler(q.get('dum'));
    if (qd || qm) {
      var dados = qd ? { dum: mais(qd, -280), metodo: 'dpp', ref: qd } : { dum: qm, metodo: 'dum', ref: qm };
      if (qd) { escolher('dpp'); inp('dpp').value = iso(qd); } else { inp('dum').value = iso(qm); }
      var r0 = calcularDe(dados.dum);
      if (r0.total >= 0 && r0.total <= 300) { mostrarResultado(dados, false); usouLink = true; }
    }
    var qs = parseInt(q.get('semana'), 10);
    if (qs && artigo(qs)) { mostrarSemana(qs, false); if (!usouLink) setTimeout(function () { raiz.querySelector('#semana-a-semana').scrollIntoView({ block: 'start' }); }, 50); }
    var hm = (location.hash || '').match(/^#semana-(\d+)$/);
    if (hm && artigo(+hm[1])) { mostrarSemana(+hm[1], false); setTimeout(function () { raiz.querySelector('#semana-a-semana').scrollIntoView({ block: 'start' }); }, 50); }
  } catch (e) {}

  if (!usouLink && retomado && ler(retomado.dum)) {
    var rr = calcularDe(ler(retomado.dum));
    if (rr.total >= 0 && rr.total <= 300) {
      $('voltarTxt').textContent = 'Hoje estás com ' + semDias(rr.total) + '. DPP: ' + curta(rr.dpp) + '.';
      $('voltar').hidden = false;
    } else lsDel(LS);
  }
  mostrarCiclo();
})();
